export const FileUploadStatus = {
  Open: 100,
  Pending: 200,
  Uploaded: 300,
  Failed: 400
}
